export enum StartDateFlexibility {
    MORE_OR_LESS_2_DAYS = 'MORE_OR_LESS_2_DAYS',
    MORE_OR_LESS_1_WEEK = 'MORE_OR_LESS_1_WEEK',
    MORE_OR_LESS_1_MONTH = 'MORE_OR_LESS_1_MONTH',
    NOT_FLEXIBLE = 'NOT_FLEXIBLE',
}

export enum StartDateType {
    ASAP = 'ASAP',
    CHOSEN_DATE = 'CHOSEN_DATE',
    UNKNOWN = 'UNKNOWN',
}
